import React from 'react'

const MemberProfileAllDetails = () => {
  return (
    <div>
      MemberProfileAllDetails 
    </div>
  )
}

export default MemberProfileAllDetails
